(function () {
  function isHanfItem(item) {
    if (!item) return false;
    var handle = String(item.handle || "").toLowerCase();
    if (handle === "hanf") return true;
    var sku = String(item.sku || "").toUpperCase();
    return sku.indexOf("HF") === 0;
  }

  function cartCountWithoutHanf(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, item) {
      return isHanfItem(item) ? sum : sum + (Number(item.quantity) || 0);
    }, 0);
  }

  function applyVisibleCartCount(count) {
    document.querySelectorAll(".cart-count-bubble").forEach(function (bubble) {
      var visible = bubble.querySelector('span[aria-hidden="true"]');
      if (visible) visible.textContent = String(count);
      if (count > 0) {
        bubble.style.display = "";
        bubble.removeAttribute("hidden");
      } else {
        bubble.style.display = "none";
      }
    });
  }

  function refreshVisibleCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    fetch(root + "cart.js", { credentials: "same-origin" })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        applyVisibleCartCount(cartCountWithoutHanf(cart));
      })
      .catch(function () {});
  }

  window.cartCountWithoutHanf = cartCountWithoutHanf;

  document.addEventListener("DOMContentLoaded", refreshVisibleCartCount);
  window.addEventListener("pageshow", refreshVisibleCartCount);
  document.addEventListener("cart:updated", refreshVisibleCartCount);
})();
